import React from "react";
import { GlideIcon } from "@glide/common";

type SearchBarProps = {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const DiscoverySearchBox = ({ value, onChange, onSubmit }: SearchBarProps & { onSubmit: () => void }) => {
    const textareaRef = React.useRef<HTMLTextAreaElement>(null);
    const resizeTextarea = React.useCallback(
        (reset = false) => {
            if (textareaRef.current) {
                const target = textareaRef.current;
                target.style.height = "auto";
                let targetHeight = target.scrollHeight > 60 && !reset ? target.scrollHeight + 16 : 36;
                if (textareaRef.current.value === "") {
                    targetHeight = 36;
                }
                target.style.height = `${targetHeight}px`;
            }
        },
        [textareaRef]
    );
    return (
        <label
            tw="relative transition duration-75 rounded border-b border-border-base pl-2 text-text-xpale flex flex-col grow w-full text-sm
              items-start cursor-text not-last:mr-2 
              after:(content-[''] absolute bottom-0 left-1/2 -translate-x-1/2 w-[60%] h-[1px] bg-gradient-to-r from-n100A via-accent to-n100A scale-x-0 origin-left transition-transform duration-200)
              focus-within:(after:scale-x-100)
              [.style-accent-bg &]:(bg-w10A page-hover:bg-w20A)
              [.style-dark &]:(bg-w10A page-hover:bg-w20A)">
            <div onClick={onSubmit} tw="shrink-0 mb-1 absolute top-2 left-2.5">
                <GlideIcon iconSize={26} kind="monotone" icon="mt-page-star-magnifying-glass" tw="mr-1.5 transition" />
            </div>
            <textarea
                ref={textareaRef}
                tw="ml-[34px] w-[calc(100%-70px)] bg-transparent text-base text-text-base placeholder-text-contextual-xpale leading-relaxed shrink resize-none h-9 overflow-hidden mr-3 mt-[9px]"
                placeholder={"Ask questions about your data"} // TODO: Localize this
                value={value}
                onChange={e => onChange(e as unknown as React.ChangeEvent<HTMLInputElement>)}
                autoFocus={true}
                onKeyDown={e => {
                    if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        onSubmit();
                    }
                }}
                rows={1}
                onInput={() => resizeTextarea(false)}
            />
            {value && (
                <button
                    onClick={() => {
                        onChange({ target: { value: "" } } as unknown as React.ChangeEvent<HTMLInputElement>);
                        resizeTextarea(true);
                    }}
                    tw="absolute top-1 right-3 text-text-contextual-base hover:text-text-contextual-accent bg-n200A p-1 rounded-full transition duration-75 mt-1"
                    aria-label="Clear search">
                    <GlideIcon iconSize={14} kind="stroke" icon="st-close" />
                </button>
            )}
        </label>
    );
};
